import { useDispatch, useSelector } from "react-redux";
import { Alert } from "react-bootstrap";

import { hideAlert } from "../../../redux/slices/alertSlice";

const AppAlert = () => {
  const dispatch = useDispatch();
  const alertSlice = useSelector((state) => state.alertSlice);

  const handleOnClose = () => {
    dispatch(hideAlert());
  };

  return alertSlice.alert ? (
    <Alert variant={alertSlice.alert.variant ?? "danger"} onClose={handleOnClose} dismissible>
      <Alert.Heading>{alertSlice.alert.headingText}</Alert.Heading>
      {alertSlice.alert.text && <p>{alertSlice.alert.text}</p>}
    </Alert>
  ) : null;
};

export default AppAlert;
